import { render, staticRenderFns } from "./StudentsTable.vue?vue&type=template&id=232e5ab1&scoped=true&"
import script from "./StudentsTable.vue?vue&type=script&lang=ts&"
export * from "./StudentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e5ab1",
  null
  
)

export default component.exports